var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room-select"},[_c('RoomSelectButton',{attrs:{"isActive":_vm.isActive}}),(_vm.isShowRoomSelect)?_c('RoomSelectContent',{attrs:{"rules":_vm.rules,"tier-info":_vm.tierInfo,"inner-height":_vm.innerHeight}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }